import React, { useEffect, useState } from "react";
import { Box, Modal } from "@mui/material";

const DocumentPreview = ({ srcList = [] }) => {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleOpen = (index) => {
    setActiveIndex(index);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? srcList.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === srcList.length - 1 ? 0 : prev + 1));
  };

  const current = srcList[activeIndex];

  useEffect(() => {
    if (!open) return;

    const keyHandler = (e) => {
      if (e.key === "Escape") handleClose();
      if (e.key === "ArrowLeft") handlePrev();
      if (e.key === "ArrowRight") handleNext();
    };

    window.addEventListener("keydown", keyHandler);
    return () => window.removeEventListener("keydown", keyHandler);
  }, [open]);

  if (!srcList.length) {
    return <Box>No document found</Box>;
  }

  const isPdf = (url) => url?.toLowerCase().endsWith(".pdf");

  return (
    <>
      {/* Thumbnails */}
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        {srcList.map((src, index) => (
          <Box
            key={index}
            onClick={() => handleOpen(index)}
            sx={{
              width: 150,
              height: 150,
              border: "1px solid #ccc",
              borderRadius: 2,
              cursor: "pointer",
              overflow: "hidden",
            }}
          >
            {isPdf(src) ? (
              <Box sx={{ p: 2, textAlign: "center" }}>PDF</Box>
            ) : (
              <img
                src={src}
                alt="doc"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </Box>
        ))}
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 20,
              right: 30,
              color: "#fff",
              fontSize: 28,
              cursor: "pointer",
            }}
            onClick={handleClose}
          >
            ×
          </Box>

          {srcList.length > 1 && (
            <Box onClick={handlePrev} sx={{ position: "absolute", left: 30, color: "#fff", cursor: "pointer" }}>
              ‹
            </Box>
          )}

          {current &&
            (isPdf(current) ? (
              <iframe src={current} style={{ width: "80%", height: "80%" }} />
            ) : (
              <img src={current} style={{ maxWidth: "90%", maxHeight: "90%" }} />
            ))}

          {srcList.length > 1 && (
            <Box onClick={handleNext} sx={{ position: "absolute", right: 30, color: "#fff", cursor: "pointer" }}>
              ›
            </Box>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default DocumentPreview;